import TemplateLayout from '@/components/layouts/TemplateLayout';
import StickyAppHeader from '@/components/molecules/sticky-app-header';
import DNSlideTab from '@/design-components/organisms/dnslide-tab';
import { Button } from 'doctornow-design-system';
import { useAdditionalOrderViewModel } from '..';
import AdditionalOrderProducts from './AdditionalOrderProducts';

const AdditionalOrderView = () => {
  const viewModel = useAdditionalOrderViewModel();

  if (!viewModel.additionalOrderCategories || viewModel.isRecommendedAdditionalOrderProductLoading) return <></>;

  return (
    <TemplateLayout.Wrapper>
      <TemplateLayout.StickyHeader>
        <StickyAppHeader
          left={true}
          etcButton={
            <span
              className='typography-ui-15m cursor-pointer text-gray-600'
              onClick={viewModel.onSkipToAdditionalOrder}
            >
              괜찮아요
            </span>
          }
        />
      </TemplateLayout.StickyHeader>
      <TemplateLayout.Content>
        <div className='flex flex-col gap-[24px]'>
          <div className='flex flex-col gap-[8px] p-[12px_24px_0]'>
            <h1 className='typography-ui-24sb whitespace-pre-wrap text-gray-900'>{viewModel.recommendedDescription}</h1>
          </div>

          <div className='mb-[80px] flex flex-col gap-[12px]'>
            <DNSlideTab value={viewModel.selectedCategoryId}>
              {viewModel.additionalOrderCategories.map((tab) => (
                <DNSlideTab.Item
                  key={tab.id}
                  label={tab.name}
                  isActive={tab.id === viewModel.selectedCategoryId}
                  onClick={() => viewModel.onClickCategoryTab(tab)}
                />
              ))}
            </DNSlideTab>

            <AdditionalOrderProducts
              additionalOrderProducts={viewModel.additionalOrderProducts}
              isLoadingAdditionalOrderProducts={viewModel.isLoadingAdditionalOrderProducts}
              hasNextPageAdditionalOrderProducts={viewModel.hasNextPageAdditionalOrderProducts}
              fetchNextPageAdditionalOrderProducts={viewModel.fetchNextPageAdditionalOrderProducts}
              getIsSelectedProduct={viewModel.getIsSelectedProduct}
              getSelectedProductCount={viewModel.getSelectedProductCount}
              onAddProductToCart={viewModel.onAddProductToCart}
              onRemoveProductFromCart={viewModel.onRemoveProductFromCart}
            />
          </div>
        </div>

        <div className='fixed right-0 bottom-0 left-0'>
          <div className='h-[24px] bg-gradient-to-b from-white/0 to-white' />
          <div className='flex items-center justify-between bg-white px-[24px] pb-[16px]'>
            {viewModel.selectedProducts.length > 0 ? (
              <Button size='xl' buttonColor='primary' className='w-full' onClick={viewModel.onSubmitOrder}>
                {viewModel.selectedProducts.length}개 상품 함께 구매
              </Button>
            ) : (
              <Button
                size='xl'
                buttonColor='gray'
                buttonStyle='outlined'
                className='w-full'
                onClick={viewModel.onSkipToAdditionalOrder}
              >
                추가 구매 없이 계속하기
              </Button>
            )}
          </div>
        </div>
      </TemplateLayout.Content>
    </TemplateLayout.Wrapper>
  );
};

export default AdditionalOrderView;
